import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import arrayToHash from 'scoreboard/components/array-to-hash'

/* Enscapsulates the event logic of handling selection of stacks for report
 * displays that use checkboxes.
 *
 * Note this doesn't account for multiple instances of one field, which should
 * be fine for now as this is used by canned reports which do not
 * define multiple instances of a single field
 */
var SelectReportStacksForm = Backbone.View.extend({

	events: {
		'change input[name=fieldIdOrColumnType]' : '_onChangeFieldIdOrColumnType',
		'change .showAbbreviatedValues' : '_onChangeShowAbbreviatedValues'
	},

	initialize: function(options) {
		this.fieldIdsOrColumnTypes = {}
		_.each(this.model.stacks().models, stack => {
			this.fieldIdsOrColumnTypes = _.extend(this.fieldIdsOrColumnTypes,
				arrayToHash(stack.fieldIdsOrColumnTypes()))
		})
	},

	render: function() {
		let self = this
		this.$('input[name=fieldIdOrColumnType]').each(function() {
			var checkbox = $(this)
			checkbox.prop('checked', !_.isUndefined(self.fieldIdsOrColumnTypes[checkbox.val()]))
		})
		this.$('input[name=showAbbreviatedValues]').prop('checked', !!this.model.get('showAbbreviatedValues'))
	},

	_onChangeShowAbbreviatedValues(e) {
		let enable = !!$(e.target).prop('checked')
		this.model.setAbbreviateValues(enable)
	},

	_onChangeFieldIdOrColumnType: function(e) {
		let checkbox = this.$(e.target)
		let fieldIdOrColumnType = checkbox.val()
		let enable = !!checkbox.is(':checked')
		let existing = _.filter(this.model.stacks().models, stack => {
			return !_.isEmpty(stack.findColumnsByFieldIdOrColumnType(fieldIdOrColumnType))
		})
		if (enable) {
			if (existing.length == 0) {
				this.model.addStack(null, fieldIdOrColumnType)
			}
		} else if (existing.length > 0) {
			_.invokeMap(existing, 'destroy')
		}
	}

})

export default SelectReportStacksForm

SelectReportStacksForm.__filename__ = 'reports/wizard/common/select-report-stacks-form.js'
